/**
 * paintByNumbers — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const paintByNumbersPack: ToilePack = {
    slug: 'paint-by-numbers',
    category: 'pbn',
    name: 'Paint by numbers',
    tagline: tagline('templates', 'subjects', 'difficulty levels'),
    chips: chips('subjects', 'levels'),
    ratio: A4,
    readings: [
        {key: 'sunset', label: 'Sunset landscape', subject: 'a low sun over open water, layered hills and birds'},
        {key: 'cat', label: 'Cat portrait', subject: 'a seated tabby cat facing forward, whiskers and ear tufts'},
        {key: 'vase', label: 'Flower vase', subject: 'tulips and daisies in a round glass vase on a table'},
    ],
    styles: [
        {key: 'beginner', label: 'Beginner', style: 'few large regions, an even medium black line', palette: 'black line only, pure white ground', framing: 'full page, numeral in each region, swatch strip'},
        {key: 'detailed', label: 'Detailed', style: 'many small regions on subtle tonal steps, fine line', palette: 'black line only, pure white ground', framing: 'full page, dense numbering, swatch strip'},
        {key: 'kids', label: 'Kids simple', style: 'very few very large rounded regions, thick bold line', palette: 'black line only, pure white ground', framing: 'full page, one big numeral per region, swatch strip'},
    ],
    directions: ['a mountain lake instead', 'fewer colors in the strip', 'in autumn colors'],
}
